import { JsonProperty, JsonObject } from 'typescript-json-serializer';

@JsonObject()
export class HubjectPricingProduct {
  @JsonProperty('ProductID') productId: string;
  @JsonProperty('ProductPriceCurrency') currency: string;
  @JsonProperty('ReferenceUnit') unit: string;
  @JsonProperty('PricePerReferenceUnit') unitPrice: number;
}
